import React from "react";
import { SvgIcon } from "@material-ui/core";

const PublishIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M15.5 14.5L12 10.5L8.5 14.5H10.5V19.5H13.5V14.5H15.5Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 17.5H6C5.60218 17.5 5.22064 17.342 4.93934 17.0607C4.65804 16.7794 4.5 16.3978 4.5 16V6C4.5 5.60218 4.65804 5.22064 4.93934 4.93934C5.22064 4.65804 5.60218 4.5 6 4.5H18C18.3978 4.5 18.7794 4.65804 19.0607 4.93934C19.342 5.22064 19.5 5.60218 19.5 6V16C19.5 16.3978 19.342 16.7794 19.0607 17.0607C18.7794 17.342 18.3978 17.5 18 17.5H16.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5 8.5H4.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default PublishIcon;
